import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Stack,
    Box,
    Button,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import * as Lucide from 'lucide-react';

export default function JsonViewerDialog({ open, protocol, onClose }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" component="div">
                        JSON (Dados Brutos)
                    </Typography>
                    <IconButton onClick={onClose} aria-label="fechar">
                        <Lucide.X />
                    </IconButton>
                </Stack>
                {protocol?.name && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        Protocolo: {protocol.name}
                    </Typography>
                )}
            </DialogTitle>
            <DialogContent dividers>
                <Box
                    component="pre"
                    sx={{
                        m: 0,
                        p: 1.5,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        maxHeight: '60vh',
                        overflow: 'auto',
                        fontSize: 13,
                        fontFamily: 'monospace',
                    }}
                >
                    {JSON.stringify(protocol, null, 2)}
                </Box>
            </DialogContent>
            <DialogActions
                sx={{
                    p: { xs: 2, sm: '16px 24px' },
                }}
            >
                <Button onClick={onClose} fullWidth={isMobile}>
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
